module.exports = __webpack_public_path__ + "static/media/ico-invitations.63462ffa.svg";